import React from 'react';
import { Lock } from 'lucide-react';
import { RobbieMark } from '../ui';

/**
 * Login v2 hero (TASK-201) — the navy left panel, pixel-ported from
 * `design/Login v2.dc.html`: nav lockup (md mark + wordmark), radial
 * cobalt/violet glows, waving xl Robbie, headline + subline, privacy footer.
 */
const LoginHero: React.FC = () => (
  <div className="relative flex flex-[1.1] flex-col justify-between overflow-hidden bg-chrome px-[52px] py-[44px] max-md:hidden">
    <div className="pointer-events-none absolute -right-[120px] -top-[120px] h-[420px] w-[420px] rounded-round bg-navy-glow-blue" />
    <div className="pointer-events-none absolute -bottom-[140px] -left-[80px] h-[380px] w-[380px] rounded-round bg-navy-glow-violet" />

    <div className="relative flex items-center gap-[10px]">
      <RobbieMark size="md" glow aria-label="Hello Robbie" />
      <span className="text-[15px] font-bold text-white">Hello Robbie</span>
    </div>

    <div className="relative max-w-[480px]">
      <div className="mb-[26px]">
        <RobbieMark size="xl" state="waving" glow aria-label="Robbie waving hello" />
      </div>
      <h1 className="mb-[12px] text-[30px] font-bold leading-[1.25] tracking-[-0.015em] text-white">
        Smarter sourcing, start to finish.
      </h1>
      <p className="text-[14.5px] leading-[1.65] text-chrome-text [text-wrap:pretty]">
        Upload a BOM and Robbie finds the suppliers, runs the outreach, and brings you quotes
        ready to award — you stay in control of every decision.
      </p>
    </div>

    <div className="relative flex items-center gap-[22px]">
      <span className="inline-flex items-center gap-s2 text-meta text-[#5F7396]">
        <Lock className="h-[13px] w-[13px]" />
        Your BOMs stay private
      </span>
      <span className="text-meta text-[#5F7396]">&copy; 2026 Hello Robbie</span>
    </div>
  </div>
);

export default LoginHero;
